import NapelemesKisokosModel from "../components/napelemes-kisokos/NapelemesKisokosModel";

const NapelemesKisokos = () => {
  return <NapelemesKisokosModel />;
};

export default NapelemesKisokos;
